import {createStudio,type StudioOptions} from './engine/studio';
import {compiledOrdinaryProgram} from './gaming/remote/ordinary-provider';
import {SelectedStudioComposition} from './gaming/remote/composition';
import {compiledCreatorQualification} from './gaming/qualification-provider';
/** The real main.tsx construction path captures one generation of the trusted local capability. */
export function createStudioApplication(options:Omit<StudioOptions,'gamingCreatorQualification'|'gamingOrdinaryProgram'>={}){
 const selected=options.embedded&&options.gamingProvider?.selected&&import.meta.env.VITE_GAMING_STUDIO_ENABLED==='true'?new SelectedStudioComposition(options.gamingProvider):undefined;
 const qualification=compiledCreatorQualification.acquire(),ordinary=compiledOrdinaryProgram.acquire();
 const unavailable=():never=>{throw Error('creator_program_unavailable');};
 const qualify:typeof qualification.qualify=selected?context=>{
  const lease=context.mounted()?.lease;
  if(lease?.timingProfile==='monotonic-causal-v1')return lease.enrollmentContext?selected.qualify(context):unavailable();
  if(lease?.timingProfile!=='qualified-rate-v1'||lease.enrollmentContext||!qualification.qualify)return unavailable();
  return qualification.qualify(context);
 }:qualification.qualify;
 const createOrdinary:typeof ordinary.create=selected?deps=>selected.selected()?selected.ordinary(deps):ordinary.create?ordinary.create(deps):unavailable():ordinary.create;
 const studio=createStudio({...options,gamingSelectedComposition:selected,gamingCreatorQualification:qualify,gamingOrdinaryProgram:createOrdinary});
 const destroy=studio.destroy.bind(studio),retire=()=>{qualification.close();ordinary.close();selected?.dispose();};
 window.addEventListener('pagehide',retire);
 studio.destroy=()=>{retire();window.removeEventListener('pagehide',retire);return destroy();};
 return studio;
}
